module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "content content-boxed"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [_c('div', {
    staticClass: "block block-bordered"
  }, [_c('div', {
    staticClass: "block block-themed"
  }, [_c('div', {
    staticClass: "block-header bg-primary-dark"
  }, [_c('ul', {
    staticClass: "block-options"
  }, [(_vm.flagDisplayBanner === 0) ? _c('li', [_c('button', {
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.toggleDisplayBanner()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-angle-double-down fa-2x"
  })])]) : _vm._e(), _vm._v(" "), (_vm.flagDisplayBanner) ? _c('li', [_c('button', {
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.toggleDisplayBanner()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-angle-double-up fa-2x"
  })])]) : _vm._e()]), _vm._v(" "), _c('h2', {
    staticClass: "block-title",
    on: {
      "click": function($event) {
        return _vm.toggleDisplayBanner()
      }
    }
  }, [_vm._v(_vm._s(_vm.labelTitleBanner[_vm.actualLanguage]))])]), _vm._v(" "), (_vm.flagDisplayBanner) ? _c('div', {
    staticClass: "block-content"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [_c('div', {
    staticClass: "block"
  }, [_c('h2', {
    staticClass: "block-title push"
  }, [_vm._v(_vm._s(_vm.labelCommissionsAvailable[_vm.actualLanguage]) + " : " + _vm._s(_vm.TotalCommissionAvailable) + "$")]), _vm._v(" "), _c('h2', {
    staticClass: "block-title push"
  }, [_vm._v(_vm._s(_vm.labelCommissionsSelected[_vm.actualLanguage]) + " : " + _vm._s(_vm.TotalCommissionSelected) + "$")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-12 col-md-6"
  }, [_c('p', [_c('button', {
    staticClass: "btn btn-success",
    attrs: {
      "type": "button",
      "name": "button"
    },
    on: {
      "click": function($event) {
        return _vm.computeTempoCommission()
      }
    }
  }, [_vm._v(_vm._s(_vm.labelButtonComputeSelected[_vm.actualLanguage]))])])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-12 col-md-6"
  }, [_c('p', [_c('button', {
    staticClass: "btn btn-success",
    attrs: {
      "type": "button",
      "name": "button"
    },
    on: {
      "click": function($event) {
        return _vm.createCommissionReport()
      }
    }
  }, [_vm._v(_vm._s(_vm.labelButtonCreateReport[_vm.actualLanguage]))])])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-12 col-md-6"
  }, [_c('p', [_c('button', {
    staticClass: "btn btn-success",
    attrs: {
      "type": "button",
      "name": "button"
    },
    on: {
      "click": function($event) {
        return _vm.getCommissionsHistory()
      }
    }
  }, [_vm._v(_vm._s(_vm.labelButtonReadHistory[_vm.actualLanguage]))])])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-sm-3"
  }, [_c('h6', [_vm._v(_vm._s(_vm.labelHistoryLength[_vm.actualLanguage]))]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.historyLength),
      expression: "historyLength"
    }],
    staticClass: "form-control align-center",
    attrs: {
      "type": "test",
      "placeholder": ""
    },
    domProps: {
      "value": (_vm.historyLength)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.historyLength = $event.target.value
      }
    }
  })]), _vm._v(" "), (_vm.commissionsIsReading) ? _c('spinner') : _c('div', {
    staticClass: "col-xs-12 col-md-12"
  }, [_c('div', {
    staticClass: "table-responsive push-50"
  }, [_c('table', {
    staticClass: "table table-bordered table-hover"
  }, [_c('thead', [_c('tr', [_c('th', {
    staticClass: "text-center",
    staticStyle: {
      "width": "120px"
    }
  }, [_vm._v(_vm._s(_vm.labelTabel01_Col01[_vm.actualLanguage]))]), _vm._v(" "), _c('th', {
    staticClass: "text-center",
    staticStyle: {
      "width": "60px"
    }
  }, [_vm._v(_vm._s(_vm.labelTabel01_Col02[_vm.actualLanguage]))]), _vm._v(" "), _c('th', {
    staticClass: "text-center",
    staticStyle: {
      "width": "100px"
    }
  }, [_vm._v(_vm._s(_vm.labelTabel01_Col03[_vm.actualLanguage]))]), _vm._v(" "), _c('th', {
    staticClass: "text-center",
    staticStyle: {
      "width": "100px"
    }
  }, [_vm._v(_vm._s(_vm.labelTabel01_Col04[_vm.actualLanguage]))]), _vm._v(" "), _c('th', {
    staticClass: "text-center",
    staticStyle: {
      "width": "120px"
    }
  }, [_vm._v(_vm._s(_vm.labelTabel01_Col05[_vm.actualLanguage]))]), _vm._v(" "), _c('th', {
    staticClass: "text-center",
    staticStyle: {
      "width": "120px"
    }
  }, [_vm._v(_vm._s(_vm.labelTabel01_Col06[_vm.actualLanguage]))])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.commissionsList), function(commission, index) {
    return _c('tr', [_c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(commission.OrganizationName))]), _vm._v(" "), _c('td', [_c('p', {
      staticClass: "font-w600 push-10"
    }, [_vm._v(_vm._s(commission.TransactionId))])]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_c('p', {
      staticClass: "font-w600 push-10"
    }, [_vm._v(_vm._s(commission.TransactionAmount) + "$")]), _vm._v(" "), _c('p', {
      staticClass: "font-w600 push-10"
    }, [_vm._v(_vm._s(commission.CommissionPourcentage) + "%")]), _vm._v(" "), _c('p', {
      staticClass: "font-w600 push-10"
    }, [_vm._v("Com:" + _vm._s(commission.CommissionAmount) + "$")])]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [(commission.PaymentReceived) ? _c('i', {
      staticClass: "fa fa-check-square"
    }) : _c('i', {
      staticClass: "fa fa-times"
    })]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [(commission.CommissionsReport == 'ND' & commission.PaymentReceived) ? _c('div', {
      staticClass: "checkbox"
    }, [_c('label', {
      attrs: {
        "for": "example-checkbox1"
      }
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (commission.FlagAddToReport),
        expression: "commission.FlagAddToReport"
      }],
      staticClass: "larger",
      attrs: {
        "type": "checkbox",
        "value": "option1"
      },
      domProps: {
        "checked": Array.isArray(commission.FlagAddToReport) ? _vm._i(commission.FlagAddToReport, "option1") > -1 : (commission.FlagAddToReport)
      },
      on: {
        "change": function($event) {
          var $$a = commission.FlagAddToReport,
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = "option1",
              $$i = _vm._i($$a, $$v);
            if ($$el.checked) {
              $$i < 0 && (_vm.$set(commission, "FlagAddToReport", $$a.concat([$$v])))
            } else {
              $$i > -1 && (_vm.$set(commission, "FlagAddToReport", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
            }
          } else {
            _vm.$set(commission, "FlagAddToReport", $$c)
          }
        }
      }
    }), _vm._v(_vm._s(_vm.labelAddToReport[_vm.actualLanguage]) + "\r\n                                                ")])]) : _vm._e()]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(commission.CommissionsReport))])])
  }), 0)])])])], 1)])])]) : _vm._e()])])])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0eda29dc","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/profile/Integrator/IntegratorCustomerPaymentHistory.vue
// module id = 1484
// module chunks = 4